exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-v-42a39e12] .blank__title{border-top-color:transparent}", ""]);

